/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetContractorsBasedOnDeviceIdsQuery
 */
export interface GetContractorsBasedOnDeviceIdsQuery {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetContractorsBasedOnDeviceIdsQuery
     */
    deviceIds?: Array<string> | null;
}

export function GetContractorsBasedOnDeviceIdsQueryFromJSON(json: any): GetContractorsBasedOnDeviceIdsQuery {
    return GetContractorsBasedOnDeviceIdsQueryFromJSONTyped(json, false);
}

export function GetContractorsBasedOnDeviceIdsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractorsBasedOnDeviceIdsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceIds': !exists(json, 'deviceIds') ? undefined : json['deviceIds'],
    };
}

export function GetContractorsBasedOnDeviceIdsQueryToJSON(value?: GetContractorsBasedOnDeviceIdsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceIds': value.deviceIds,
    };
}


